import React from 'react';
import { Link } from 'react-router-dom';

const AuthNavbar = () => {
  return (
    <nav style={{
      backgroundColor: '#007bff',
      padding: '1rem 2rem',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    }}>
      {/* Brand Logo */}
      <Link to="/" style={{ 
        textDecoration: 'none', 
        color: 'white', 
        fontSize: '1.5rem', 
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        OnRoad Assist 🛠️
      </Link>

      {/* Simple Link */}
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
        <Link to="/contact" style={{ 
          color: 'white', 
          textDecoration: 'none', 
          fontSize: '14px',
          fontWeight: '500',
          border: '1px solid rgba(255,255,255,0.5)',
          padding: '5px 15px',
          borderRadius: '20px'
        }}>
          Need Help?
        </Link>
      </div>
    </nav>
  );
};

export default AuthNavbar;